<template>
    <div>UserChangelog</div>
</template>

<script>
export default {
    name: 'UserChangelog',
};
</script>

<style lang="scss" scoped></style>
